import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(inventory)/branch/_layout/inventory/pending-acceptance-inventory/-components/component";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";
import { PricingPendingAcceptanceResponse } from "@/gen/medical_master/pricing_pending_acceptance_pb";

export const Route = createFileRoute("/(inventory)/branch/_layout/inventory/pending-acceptance-inventory/")({
    component: Component,
    validateSearch: SearchParams,
    loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
    loader: async (params): Promise<PricingPendingAcceptanceResponse> => {
        return await pharmacyClient.pricingPendingAcceptance({
            page: params.deps.page,
            pageSize: params.deps.pageSize
        })
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});